import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui';
import { ReactComponent as CloseIcon } from '../../SVG/close_icon.svg'
import StyledSvgIcon from './StyledSvgIcon';
import { ExtendedDialogProps } from '../../constants/interfaces';

const useStyles = makeStyles()((theme) => ({
  dialog: {
    [theme.breakpoints.down('sm')]: {
      margin: -16,
    },
  },
  dialogTitleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '5px 20px'
  },
  dialogTitle: {
    width: '100%',
    alignContent: 'center',
    fontWeight: 600,
  },
  dialogContent: {
    minHeight: '100px',
    maxHeight: '70vh',
    marginTop: '10px',
    marginBottom: '20px',
  },
  closeButton: {
    color: theme.palette.grey[500],
  },
  dialogSubtitle: {
    marginTop: '10px',
    fontSize: '14px', 
    fontWeight: 300
  }
}))

export default function StyledDialog(props: ExtendedDialogProps) {
  const { classes } = useStyles();
  const { open, children, onClose, maxWidth, fullWidth, fullScreen, dialogTitle, dialogSubtitle, titleBar } = props;

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth={fullWidth}
        fullScreen={fullScreen}
        maxWidth={maxWidth}
        className={classes.dialog}
      >
        <DialogTitle className={classes.dialogTitleWrapper} style={titleBar && {background: titleBar} || {}}>
          <Typography className={classes.dialogTitle} variant="h2">
            {dialogTitle}
          </Typography>
          {
            dialogSubtitle
              &&
            <Typography className={classes.dialogSubtitle}>
              {dialogSubtitle}
            </Typography>
          }
          <IconButton aria-label="close" className={classes.closeButton} onClick={(event) => onClose && onClose(event, 'backdropClick')}>
            <StyledSvgIcon viewBox='0 0 48 48' component={CloseIcon} style={{ fontSize: '48px', color: 'black' }} />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {children}
        </DialogContent>
      </Dialog>
    </>
  )
}